import { useCurrentUserContext } from '@/contexts';
import { useLauncherAction } from '@/hooks/useLauncher';
import { useOpenRegisterModal } from './store';

/**
 * Opens the register modal when landing with `?launch=signup` (e.g. from an
 * invite link) so a logged-out visitor can sign up.
 *
 * Consuming the action waits for the profile query to resolve —
 * `isAuthenticated` is false while the profile is still loading, so acting
 * sooner would open the modal for already-authenticated users.
 */
export const useSignupLaunchAction = () => {
  const { isAuthenticated, isLoading } = useCurrentUserContext();
  const { openRegisterModal } = useOpenRegisterModal();

  useLauncherAction(
    'signup',
    (params) => {
      if (!isAuthenticated) {
        openRegisterModal({ defaults: params });
      }
    },
    { enabled: !isLoading }
  );
};
